// extracted by mini-css-extract-plugin
module.exports = {"table":"styles-module_table_2Nxf5","edit":"styles-module_edit_1mhG5","buttons":"styles-module_buttons_XcNm9"};